<template>
  <div class="mt-gd-2">
    <b-overlay :show="loading" variant="white" :opacity="1" rounded="sm">
      <div class="grid-file-unsplash">
        <div
          v-for="(file, file_index) in filelist"
          :key="`file_index${file_index}`"
          class="position-relative"
        >
          <FileWrapper
            @click="
              fileHighlight = file;
              toggleSelect(
                $event,
                file,
                file_index,
                selected_uniq[`${file.id}`]
              );
            "
            :class="{
              active: selected_uniq[`${file.id}`],
              hightlight: fileHighlight && fileHighlight.id == file.id,
            }"
          >
            <FileThumbnail
              v-if="file.urls && file.urls.thumb"
              :imgsrc="file.urls.thumb"
            />
            <div v-else class="center-hv" style="color: #ced4da">
              <i class="far fa-images fa-3x"></i>
            </div>
          </FileWrapper>

          <SelectedFile
            @click="sliceFromSelected(file.id)"
            @mouseover="hoverItem = file.id"
            @mouseleave="hoverItem = 0"
          >
            <div v-show="hoverItem !== file.id">
              <div
                v-show="
                  selected_uniq[`${file.id}`] &&
                  !(fileHighlight && fileHighlight.id === file.id)
                "
              >
                <i class="far fa-check-circle"></i>
              </div>
              <div v-show="fileHighlight && fileHighlight.id === file.id">
                <i class="fas fa-check-circle"></i>
              </div>
            </div>

            <div v-show="hoverItem === file.id">
              <div
                v-show="
                  selected_uniq[`${file.id}`] &&
                  !(fileHighlight && fileHighlight.id === file.id)
                "
              >
                <i class="far fa-minus-circle"></i>
              </div>
              <div v-show="fileHighlight && fileHighlight.id === file.id">
                <i class="fas fa-minus-circle"></i>
              </div>
            </div>
          </SelectedFile>
        </div>
      </div>

      <div v-show="filelist.length === 0 && !loading" class="fs-sa-14 text-center">
        {{$t('engine.filemanager.unsplash.cantFind', languageEngine)}}
      </div>

      <infinite-loading
        v-if="isHasMoreFile"
        spinner="spiral"
        @infinite="infiniteHandler"
      ></infinite-loading>
    </b-overlay>
  </div>
</template>

<script>
import { FileWrapper, FileThumbnail, SelectedFile } from "./Filemanager.styled";
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      hoverItem: 0,
      fileSelected: [],
      fileHighlight: undefined,
    };
  },
  components: {
    FileWrapper,
    FileThumbnail,
    SelectedFile,
    InfiniteLoading,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    selected_uniq() {
      return this.fileSelected.reduce(
        (acc, file) => ((acc[`${file.id}`] = true), acc),
        {}
      );
    },
    fileSource() {
      let type = "";
      switch (this.selectDirectoryType) {
        case "system":
          type = "website";
          break;
        case "unsplash":
          type = "unsplash";
          break;
        case "flaticon":
          type = "flaticon";
          break;
        default:
          type = "mwe";
          break;
      }
      return type;
    },
  },
  watch: {
    fileHighlight: {
      handler() {
        this.$emit("setFileHightLight", this.fileHighlight);
      },
    },
    fileSelected: {
      handler() {
        this.$emit("setFileSelected", this.fileSelected);
      },
    },
  },
  methods: {
    infiniteHandler($state) {
      if (this.isHasMoreFile) {
        this.options.p += 1;
        this.$emit("callback", this.options);
        setTimeout(() => {
          $state.loaded();
        }, 1500);
      }
    },
    clearFileSelected() {
      this.fileSelected = [];
      this.fileHighlight = undefined;
    },
    normalizeFile(file) {
      return { ...file, type: this.fileSource };
    },
    normalizeFiles(files = []) {
      let _files = [];
      files.forEach((file) => {
        _files.push({ ...file, type: this.fileSource });
      })
      return _files;
    },
    toggleSelect(e, file, endIndex, isActive) {
      const _file = this.normalizeFile(file);
      if (isActive && !e.shiftKey) {
        if (
          this.fileSelected.length === 1 &&
          this.fileSelected[0].id === _file.id
        ) {
          this.clearFile();
        } else {
          this.fileHighlight = _file;
        }
        return;
      } else if (this.limit > 1 && e.shiftKey && this.fileSelected.length > 0) {
        const startIndex = this.filelist.findIndex(
          (list) => list.id === this.fileSelected[0].id
        );
        this.fileSelected = [];
        if (startIndex > endIndex) {
          const a = this.filelist.slice(endIndex, startIndex + 1);
          this.fileSelected = this.normalizeFiles([...a.reverse()]);
        } else {
          const a = this.filelist.slice(startIndex, endIndex + 1);
          this.fileSelected = this.normalizeFiles([...a]);
        }
      } else if (this.limit > 1 && (e.ctrlKey || e.metaKey)) {
        const findIndex = this.fileSelected.findIndex(
          (item) => item.id === _file.id && item.source === _file.source
        );
        if (findIndex > -1) {
          this.fileSelected.splice(findIndex, 1);
        } else {
          this.fileSelected.push(_file);
        }
      } else {
        this.fileSelected = [_file];
      }
      const arrayCopy = [...this.fileSelected];
      this.fileHighlight = arrayCopy.pop();
      this.checkOverLimitToSelect();
    },
    checkOverLimitToSelect() {
      if (this.fileSelected.length > this.limit) {
        this.$bvModal.show("modal-limit-select");
      }
    },
    toggleMultiSelect() {
      this.fileSelected = this.normalizeFiles([...this.filelist]);
      const arrayCopy = [...this.fileSelected];
      this.fileHighlight = arrayCopy.pop();
      this.checkOverLimitToSelect();
    },
    sliceFromSelected(id) {
      const index = this.fileSelected.findIndex((file) => file.id == id);
      this.fileSelected.splice(index, 1);
      const arrayCopy = [...this.fileSelected];
      this.fileHighlight = arrayCopy.pop();
    },
    clearFile() {
      this.fileHighlight = undefined;
    },
    setFileHighLight(value) {
      this.fileHighlight = value;
    },
    setFileSelected(value, clear) {
      if (clear) {
        this.fileSelected = [];
      }
      this.fileSelected.push(this.normalizeFile(value));
    },
  },
  props: {
    selectDirectoryType: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isHasMoreFile: {
      type: Boolean,
      default: false,
    },
    fileTotalCount: {
      type: Number,
      default: 0,
    },
    filelist: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 1,
    },
    options: {
      type: Object,
      default: () => {
        return {
          p: 1,
          take: 30,
          name: "",
          categoryID: 0,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-file-unsplash {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
}
</style>
